import { Router, Routes } from '@angular/router';
import { IntranetComponent } from './layout/intranet/intranet.component';
import { ExtranetComponent } from './layout/extranet/extranet.component';
import { LandingPageComponent } from './features/landing-page/landing-page.component';
import { authGuard } from './shared/guards/auth/auth-guards.guard';
import { guestGuard } from './shared/guards/guest/guest-guard.guard';
import { accountTypeGuard } from './shared/guards/account-type/account-type-guard.guard';
import { permissionsGuard } from './shared/guards/permissions/permissions-guard.guard';

export const routes: Routes = [
  {
    path: '',
    component: ExtranetComponent,
    canActivate: [guestGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: LandingPageComponent,
      },
      {
        path: 'auth',
        loadChildren: () =>
          import('./features/auth/auth.routes').then((m) => m.AuthRoutes),
      },
    ],
  },
  {
    path: 'admin',
    component: IntranetComponent,
    canActivate: [authGuard],
    canActivateChild: [accountTypeGuard, permissionsGuard],
    loadChildren: () =>
      import('./features/admin/admin.routes').then((m) => m.AdminRoutes),
  },
  {
    path: 'user',
    component: IntranetComponent,
    canActivate: [authGuard],
    canActivateChild: [accountTypeGuard, permissionsGuard],
    loadChildren: () =>
      import('./features/user/user.routes').then((m) => m.UserRoutes),
  },
  { path: '**', redirectTo: '' },
];
